import React from 'react';
import { Routes, Route } from 'react-router-dom';
import TicketList from './TicketList';
import TicketDetail from './TicketDetail';
import './SupportTickets.css';

const SupportTickets = () => {
  return (
    <div className="support-tickets-container">
      <Routes>
        <Route path="support" element={<TicketList />} />
        <Route path="support/:ticketId" element={<TicketDetail />} />
      </Routes>
    </div>
  );
};

export default SupportTickets;
